var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass:
        "link font-14 padding-y-8 padding-left-5 position-relative font-light",
      class: {
        "mouse-in": _vm.status === "in",
        "mouse-out": _vm.status === "out",
      },
      on: {
        click: _vm.goPage,
        mouseover: _vm.onMouseOver,
        mouseout: _vm.onMouseOut,
      },
    },
    [_c("span", { domProps: { innerHTML: _vm._s(_vm.title) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }